export default "__VITE_ASSET__f6289486__"